import { Navigate, useLocation } from "react-router-dom";
import { buildLocalePath, detectPreferredLanguage } from "./localePath";

export function LocaleRedirect() {
  const { pathname, search, hash } = useLocation();
  const lang = detectPreferredLanguage();
  const target = buildLocalePath(lang, pathname);
  return <Navigate to={`${target}${search}${hash}`} replace />;
}
